import { render } from "./app-header.vue?vue&type=template&id=3a7e7f9f"
import script from "./app-header.vue?vue&type=script&lang=js"
export * from "./app-header.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/layout/app-header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a7e7f9f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a7e7f9f', __exports__)) {
    console.log('reload')
    api.reload('3a7e7f9f', __exports__)
  }
  
  module.hot.accept("./app-header.vue?vue&type=template&id=3a7e7f9f", () => {
    console.log('re-render')
    api.rerender('3a7e7f9f', render)
  })

}


export default __exports__